import React from 'react';
import loyaltyProgramConstants from 'constants/loyaltyProgram';
import GetSvg from '../../vendor/GetSvg';
import { getTierKey } from './tiers';

const TierCircle = ({ status, label }) => (
  <div
    className={`loyalty-program__tier loyalty-program__tier--${getTierKey(
      status,
    )}`}>
    <span className="loyalty-program__tier-label">{label}</span>
    {status === loyaltyProgramConstants.STATUS_EXCLUSIVE ? (
      <div className="loyalty-program__tier-crown">
        <GetSvg
          svg="exclusive"
          wrapperClass="svg loyalty-program__tier-crown-icon"
        />
      </div>
    ) : null}
  </div>
);

export default TierCircle;
